/* eslint-disable no-use-before-define, import/newline-after-import, import/first */

/*
  Rewrites the selectors so that they select from the domain they are in
  eg: selectors declared in post/selectors.js are to be called with state.post
 */
const selectDomain = (selectors, domain) => {
  const transformed = {}
  Object.keys(selectors).forEach(key => {
    transformed[key] = (state, ...args) =>
      selectors[key](state[domain], ...args)
  })
  return transformed
}

import * as authSelectors from './auth/selectors'
export const fromAuth = selectDomain(authSelectors, 'auth')

import * as contextSelectors from './context/selectors'
export const fromContext = selectDomain(contextSelectors, 'context')

import * as firmSelectors from './firm/selectors'
export const fromFirm = selectDomain(firmSelectors, 'firm')

import * as routingSelectors from './routing/selectors'
export const fromRouting = selectDomain(routingSelectors, 'routing')

import * as tradesSelectors from './trades/selectors'
export const fromTrades = selectDomain(tradesSelectors, 'trades')

import * as statusSelectors from './status/selectors'
export const fromStatus = selectDomain(statusSelectors, 'status')

import * as userSelectors from './user/selectors'
export const fromUser = selectDomain(userSelectors, 'user')

import * as directorySelectors from './directory/selectors'
export const fromDirectory = selectDomain(directorySelectors, 'directory')

import * as proSelectors from './pro/selectors'
export const fromPro = selectDomain(proSelectors, 'pro')

import * as googleSelectors from './google/selectors'
export const fromGoogle = selectDomain(googleSelectors, 'google')

import * as cloudinarySelectors from './cloudinary/selectors'
export const fromCloudinary = selectDomain(cloudinarySelectors, 'cloudinary')

import * as productSubscriptionSelectors from './productSubscription/selectors'
export const fromProductSubscription = selectDomain(
  productSubscriptionSelectors,
  'productSubscription',
)

import * as jobSelectors from './job/selectors'
export const fromJob = selectDomain(jobSelectors, 'job')

import * as onboardingSelectors from './onboarding/selectors'
export const fromOnboarding = selectDomain(onboardingSelectors, 'onboarding')

import * as surveySelectors from './survey/selectors'
export const fromSurvey = selectDomain(surveySelectors, 'survey')

import * as documentsSelectors from './pro-documents/selectors'
export const fromDocuments = selectDomain(documentsSelectors, 'proDocuments')

import * as notificationsSelectors from './notifications/selectors'
export const fromNotifications = selectDomain(
  notificationsSelectors,
  'notifications',
)

import * as departmentsSelectors from './departments/selectors'
export const fromDepartments = selectDomain(
  departmentsSelectors,
  'proDocuments',
)
